<template>
    <div class="pichi-tunnel-tab">
        <div class="footerTabWrapper">
            <ul class="footerTab">
                <li>
                    <div
                        class="newTab"
                        @click="newTab"
                    >
                        新規作成
                    </div>
                </li>
                <li
                    v-for="(d,index) in tabData.data"
                    :key="index"
                >
                    <div
                        class="footerTabName"
                        @click="changeTabIndex(index)"
                    >
                        <span>{{ d.savedStandardBalls[0].pitcher.name + selectedSearch(d.PT2) }}</span>
                    </div>
                    <span
                        class="delete"
                        @click="deleteTab(index)"
                    >×</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import setting from '@/setting'
import common from '@/common'

export default {
    name: "PichiTunnelTab",
    props: ['tabData'],
    emits: ['change-tab', 'delete-tab'],
    methods: {
        changeTabIndex (index) {
            this.$emit('change-tab', index)
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '条件タブ切り替え', index)
        },
        deleteTab (index) {
            if (!window.confirm('削除しますか？')) return
            this.$emit('delete-tab', index)
            const tabIndex = ((index) => {
                if (index === 0 && this.tabData.data.length === 1) {
                    return 999
                } else if (index === 0) {
                    return 0
                } else {
                    return index - 1
                }
            })(index)
            console.log(tabIndex + 'tabINdex')
            this.$emit('change-tab', tabIndex)
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '条件タブ削除', index)
        },
        newTab () {
            const ptData = this.$ls.get(setting.sessionKey.pt1Tabs)
            if (ptData.data.length >= 5) {
                this.$alert('作成出来るデータは最大5件です。データを削除してください')
            } else {
                // ローカルストレージ一旦初期化
                this.initLocalStorage()
                // タブデータのindex
                ptData.index = ptData.data.length
                this.$ls.set(setting.sessionKey.pt1Tabs, ptData)
                this.$router.push('PitchiTunnelSearch')
                common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '新規作成')
            }
        },
        initLocalStorage () {
            // PT2Hシークバー初期化
            this.$ls.set(setting.sessionKey.pt2ChangeAmountThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                ptTime: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2H選択された投球1,2
            this.$ls.set(setting.sessionKey.pt2ConfirmationChangeAmountBall1, {})
            this.$ls.set(setting.sessionKey.pt2ConfirmationChangeAmountBall2, {})
            // 変化量選定のゾーン等
            this.$ls.set(setting.sessionKey.pt2HomeBallContent, {
                selectedZone: [],
                renderBall1: [],
                renderBall2: [],
                thresholdBall2: [],
                dataLoadFlag: false,
            })

            //PT2S シークバー
            this.$ls.set(setting.sessionKey.pt2S1ThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                pt: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2S 選択された投球1,2
            this.$ls.set(setting.sessionKey.pt2SSelectedBall1, [])
            this.$ls.set(setting.sessionKey.pt2SSelectedBall2, [])

            // 検索コンポーネント関連
            this.$ls.set(setting.sessionKey.pt2Search, {})
            this.$ls.set(setting.sessionKey.pt2SearchTmp, {})
        },
        selectedSearch (search) {
            return search === 'H' ? '(変化量)' : '(閾値)'
        }
    }
}
</script>

<style scoped>

.footerTabWrapper {
    height: 27px;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: 2px solid #fff;
    z-index: 2;
}

.footerTab {
    color: #fff;
    width: 100%;
    background: #000;
}

li {
    border-right: 1px solid #fff;
    font-size: 12px;
    width: 185px;
    position: relative;
}

li:nth-child(1) {
    width: 100px;
}

.delete {
    position: absolute;
    right: 10px;
}


</style>
